// Reads a query's cached data without observing the query. An observer, even a disabled one, creates the query empty,
// and a HydrationBoundary below then leaves the existing query to an effect, which never runs on the server: the
// layout's server render would fail. For code that may render outside the Hub layout. Not above its HydrationBoundary:
// the data lands there while the page hydrates, and an update above a hydrating page makes React render it again.
import { useQueryClient, type QueryKey } from '@tanstack/react-query';
import { useCallback, useSyncExternalStore } from 'react';

export function useCachedQueryData<Data>(queryKey: QueryKey) {
  const queryClient = useQueryClient();
  const subscribe = useCallback((onChange: () => void) => queryClient.getQueryCache().subscribe(onChange), [queryClient]);
  const read = () => queryClient.getQueryData<Data>(queryKey);
  return useSyncExternalStore(subscribe, read, read);
}
